
export interface Parameter {
    countryCode?: string;
    parameterCode?: string;
    parameterId?: number;
    value1?: string;
    parameterGroup?: string;
}

export interface ParameterGroup {
    parameterGroup?: string;
    parameters?: Array<Parameter>;
}
